import React, { useState, useEffect, useCallback } from "react";
import DataTable from "react-data-table-component";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { api } from "../../api";
import { customStyles } from "../../styles/dataTableStyles";

const Logs = () => {
  const token = useSelector((state) => state.auth.token);
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [search, setSearch] = useState("");

  const fetchLogs = useCallback(async (pageNo,searchKey, pageSize) => {
    try {
      setLoading(true);
      const response = await api.logs.getLogs({ pageNo, pageSize, sort: "asc", searchKey },token); // Adjust API call as needed
      if (response.data.result) {
        setLogs(response.data.result);
        setTotalRows(response.data.totalCount || 0);
      } else {
        setLogs([]);
        setTotalRows(0);
      }
    } catch (error) {
      toast.error("Error fetching logs");
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
          setPage(1);
        // eslint-disable-next-line
      }, [search]);

  useEffect(() => {

    fetchLogs(page, search, pageSize);
  }, [page, pageSize,search,fetchLogs]);

  const columns = [
    {
      name: "S.No",
      selector: (row, index) => (page - 1) * pageSize + index + 1,
      width: "80px"
    },
    {
      name: "Name",
      selector: (row) => row.apiName || "",
      wrap: true,
   
       width: "250px"
    },
    {
      name: "Status",
      selector: (row) => row.responseStatus || "",
      width: "120px"
    },
    {
      name: "IP Address",
      selector: (row) => row.ip || "",
      width: "150px"
    },
    {
      name: "Date",
      selector: (row) => new Date(row.createdDate).toLocaleDateString("en-CA") || "",
      width: "150px"
    },
    {
      name: "Time",
      selector: (row) => row.executionTime || "",
      width: "100px"
    }
  ];

  return (
    <div className="container-fluid mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2 className="sec-header">LOGS</h2>
           <div className="d-flex align-items-center">
          <label className="mr-2">Search:</label>
          <input
            type="text"
            placeholder="Search"
            className="form-control"
            style={{ width: "200px" }}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          
        </div>
      </div>

      <DataTable
        columns={columns}
        data={logs}
        progressPending={loading}
        pagination
        paginationServer
        paginationTotalRows={totalRows}
        onChangePage={setPage}
        onChangeRowsPerPage={(newPageSize, newPage) => {
          setPageSize(newPageSize);
          setPage(newPage);
        }}
        paginationDefaultPage={page}
        highlightOnHover
        customStyles={customStyles}
        responsive
        wrap
      />
    </div>
  );
};

export default Logs;
